import type { RouteRecordRaw } from 'vue-router'

// Routes of the interview area. meta.account: requires a signed-in account.
// The directory and mode picker are public (the catalog is public); sessions need an account.
export const routes: RouteRecordRaw[] = [
  { path: '/interview', name: 'interview', component: () => import('./IndexView.vue') },
  { path: '/interview/history', name: 'interview-history', component: () => import('./HistoryView.vue'), meta: { account: true } },
  { path: '/interview/session/:sessionId', name: 'interview-session', component: () => import('./SessionView.vue'), props: true, meta: { account: true } },
  { path: '/interview/:region', name: 'interview-region', component: () => import('./RegionView.vue'), props: true },
]
